import React from 'react';
import {useRouter} from 'next/router';

import DropdownInput from '../../components/DropdownInput';
import {createURLWithParams} from '../../util';
import {useAnalytics} from '../../hooks';

const QuestionListSort = ({isGated, onClickPaywalledContent}) => {
  const {tracker} = useAnalytics();
  const {push, query} = useRouter();

  const sortByOptions = [
    {label: '🔥 Hot', value: 'hot'},
    {label: '🚀 Top', value: 'most-popular'},
    {label: '✨ New', value: 'newest'},
  ];

  const onChange = (val) => {
    tracker.questionListSortBy({sort: val});

    if (isGated) {
      onClickPaywalledContent();
    } else {
      const url = createURLWithParams('/questions', {
        ...query,
        sortBy: val,
        page: 1,
        src: undefined,
      }, {arrayFormat: 'repeat'});
      push(url);
    }
  };

  return (
    <DropdownInput
      value={query.sortBy || 'hot'}
      options={sortByOptions}
      onChange={onChange}
      showReset={false}
      highlightActive={false}
      align="right"
    />
  );
};

export default QuestionListSort;
